// File: src/auth/ui/VerifyEmail.tsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, Flex, Text, Title} from '@mantine/core';
import {BackendUrl} from "../../util/config";

const VerifyEmail: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token'); // e.g. ?token=ABC123
    const navigate = useNavigate();

    const [message, setMessage] = useState<string>('');
    const [error, setError] = useState<string>('');

    useEffect(() => {
        // If no token in URL, show error
        if (!token) {
            setError('No verification token provided.');
            return;
        }

        // Attempt to verify
        const verify = async () => {
            try {
                // Adjust the backend endpoint as needed (e.g., /auth/verify)
                const response = await axios.post(BackendUrl + `/auth/verify?token=${token}`);
                // e.g. response.data = { message: "Email verified successfully!" }.
                setMessage(response.data.message || 'Your email has been verified!');
            } catch (err: any) {
                // Handle error response from backend
                setError(err?.response?.data?.error || 'Verification failed.');
            }
        };

        verify();
    }, [token]);

    const handleGoToLogin = () => {
        navigate('/login');
    };

    return (
        <Flex justify={"center"} align={"center"} h={"100vh"} >
            <Flex align={"flex-start"} direction={"column"}>
                <Title order={2} mb="md">Email Verifizierung</Title>
                {message && (
                    <Text color="green" mb="sm">
                        {message}
                    </Text>
                )}

                {error && (
                    <Text color="red" mb="sm">
                        {error}
                    </Text>
                )}

                <Button onClick={handleGoToLogin}>Zur Anmeldung</Button>
            </Flex>
        </Flex>
    );
};

export default VerifyEmail;
